module.exports = __webpack_public_path__ + "static/media/DMC3-FM3.bfe8bb6f.czml";